import styled from 'styled-components';

import { colors, fontSizes, fonts } from 'shared/defaultTheme';
import { TextField } from 'shared/components/form/Inputs';

export const ShareNotifyContactsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .form-container {
    height: 620px;
    overflow: auto;
  }
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .client-name-box {
    height: 37px;
    background-color: ${colors.whiteSmoke};
    padding: 8px;
    strong {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .document-select-all-client {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
  }
  .list-contact {
    color: ${colors.zambezi};
    font-family: ${fonts.roboto};
    font-size: 13px;
    letter-spacing: 0;
    line-height: 25px;
  }
  .contact-box-container {
    box-sizing: border-box;
    border: 1px solid ${colors.pattens};
    border-radius: 4px;
    height: 244px;
    overflow: auto;
    .search-contacts-container {
      height: 36px;
      border-radius: 4px 4px 0 0;
      background-color: ${colors.whiteSmoke};
    }
  }
  .search-contacts-form {
    width: 100%;
    .form__form-group-field {
      border: none;
      &:focus,
      &:active {
        border: none;
      }
    }
  }
`;

export const SearchContacts = styled(TextField)`
  width: 100% !important;
  input {
    color: ${colors.black};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;
